var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.196,
    height: 16.349,
    viewBox: "0 0 24.196 16.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-svgrepo-com_1_",
    "data-name": "email-svgrepo-com (1)",
    transform: "translate(-22.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9792",
    "data-name": "Group 9792",
    transform: "translate(22.486 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9791",
    "data-name": "Group 9791",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80163",
    "data-name": "Path 80163",
    d: "M24.453,16.349H44.716a1.967,1.967,0,0,0,1.967-1.963V1.963A1.966,1.966,0,0,0,44.73,0l-.01,0H24.448l-.01,0a1.966,1.966,0,0,0-1.952,1.961V14.386A1.967,1.967,0,0,0,24.453,16.349Zm.205-1.308,6.7-7.262,2.785,2.515a.653.653,0,0,0,.876,0l2.785-2.515,6.7,7.262ZM44.925,1.35a.65.65,0,0,1,.449.612V14.05L38.777,6.9Zm-1.9-.042-8.437,7.62-8.437-7.62Zm-19.228.655a.65.65,0,0,1,.449-.612L30.391,6.9l-6.6,7.147Z",
    transform: "translate(-22.486 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.3b372673621ad3c0535722242749e5f8.svg";
export { ForwardRef as ReactComponent };